/**
 * Translation resources, bundled statically.
 *
 * Vite inlines these JSON files into the hashed asset graph at build time, so
 * i18next initialises synchronously — no Suspense boundary, no loading flash,
 * nothing to copy into public/, and the same code path works in the vitest
 * environment. There is no SSR here, so lazy loading would buy nothing today.
 * If the payload ever justifies it, switching to i18next-resources-to-backend
 * + dynamic import() is a change to THIS FILE ONLY, precisely because the
 * namespaces are already split.
 *
 * ONE LINE PER NAMESPACE. Namespaces mirror the feature domains under
 * src/features/ (kpi, visualization, graph, variants, rootcause, ocel,
 * file-manager, filter, conformance, etl-monitor, misc); `common` covers
 * src/components/, src/pages/ and layout. Each domain's migration plan adds
 * its own two JSON files and its own line here — see docs/i18n-migration.md.
 *
 * Deliberately NOT pre-seeded with empty namespace files: an empty namespace
 * would read as "migrated" in the progress register while containing nothing.
 */

import deCommon from './locales/de/common.json';
import enCommon from './locales/en/common.json';
import deFileManager from './locales/de/file-manager.json';
import enFileManager from './locales/en/file-manager.json';
import deFilter from './locales/de/filter.json';
import enFilter from './locales/en/filter.json';
// `tiles` is the one namespace that does NOT mirror a features/ folder: the
// chart tiles live in components/features/, which is a catch-all rather than a
// domain. One namespace per tile would be overhead for ~6 files.
import deTiles from './locales/de/tiles.json';
import enTiles from './locales/en/tiles.json';
import deAdmin from './locales/de/admin.json';
import enAdmin from './locales/en/admin.json';

const resources = {
  de: {
    common: deCommon,
    'file-manager': deFileManager,
    filter: deFilter,
    tiles: deTiles,
    admin: deAdmin,
  },
  en: {
    common: enCommon,
    'file-manager': enFileManager,
    filter: enFilter,
    tiles: enTiles,
    admin: enAdmin,
  },
};

export default resources;
